enum PregnancyDatingMethod {
    FirstTrimesterUltrasound,
    SecondTrimesterUltrasound,
    LastMenstrualPeriod,
    IntrauterineInsemination,
    EmbryoTransfer,
    Other
}

export { PregnancyDatingMethod };
